import React from 'react';

const ArrowTop: React.FC = () => (
   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 3.00001L12 21" stroke="#196DEB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 9L12 3L18 9" stroke="#196DEB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
   </svg>
);

export default ArrowTop;